/* prettier-ignore */
const colorPerHarvest = {
    'Soja': 'rgba(63,150,139,1)',
    'Milho': 'rgba(239,187,0,1)',
    'Feijão': 'rgba(221,106,87,1)',
    'Algodão': 'rgba(16,183,220,1)',
    'Trigo': 'rgba(237,159,74,1)',
    'Aveia': 'rgba(126,95,177,1)',
    'Cobertura': 'rgba(98,192,84,1)',
    'Pousio': 'rgba(52,107,200,1)',
    'Sorgo': 'rgba(177,95,164,1)',
};

export const convertHarvestInColors = (harvestArray) => {
    return harvestArray.map((harvest) => {
        return colorPerHarvest[harvest] ? colorPerHarvest[harvest] : '#000000';
    });
};
